import React, {Component} from "react";

export default class FontAwesome extends Component {
    render() {
        const size = this.props.size ? this.props.size : '1x';
        const name = this.props.name;
        const red = this.props.red ? ' red-color' : '';
        const spin = this.props.spin ? ' fa-spin' : '';
        const fixedWith = this.props.fixedWidth ? ' fa-fw' : '';
        return (
            <span className={"fal fa-" + size + " fa-" + name + "" + red + "" + spin + "" + fixedWith}/>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/FontAwesome.js